<template>
  <div :id="id" :class="className" :style="{ height: height, width: width }" />
</template>

<script>
import * as echarts from "echarts";
import resize from "./mixins/resize";

export default {
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: "chart",
    },
    id: {
      type: String,
      default: "chart",
    },
    width: {
      type: String,
      default: "200px",
    },
    height: {
      type: String,
      default: "200px",
    },
    chartdata: {
      type: Array,
      require: true,
      // eslint-disable-next-line vue/require-valid-default-prop
      default: [],
    },
  },
  data() {
    return {
      chart: null,
    };
  },
  watch: {
    $props: {
      handler(val, oldvalue) {
        //console.log("val",val,"oldvalue",oldvalue)
        if (this.chart) {
          this.chart.dispose();
        }
        this.initChart();
      },
      deep: true,
    },
  },
  mounted() {
    // this.$nextTick(()=>{
    //   this.initChart()
    // })
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    initChart() {
      //console.log(222,this.id)
      this.chart = echarts.init(document.getElementById(this.id));
      //console.log("data",this.chartdata[0],this.$props.chartdata)
      const multiGrid = [];
      const multiXAxis = [];
      const multiYAxis = [];
      const multiSeriesData = [];
      const multiTooltip = [];
      const multixAxisIndex = [];
      let multiTile = []
      this.$props.chartdata.forEach((item, i) => {
        //console.log(1,i)
        let dataseries = [];
        const yheight = 160 + (i - 1) * 130; //每個高度
        // multiTile.push({
        //     gridIndex: i,
        //     text:item.name
        // })
        multiGrid.push({
          x: "7%",
          width: "80%",
          height: "7%",
          left: '15%',
          right: '20%',
          top: yheight + "px",
        });
        multiTooltip.push({
          trigger: "axis",
          axisPointer: {
            animation: false,
          },
        });
        multixAxisIndex.push(i);
        multiXAxis.push({
          gridIndex: i,
          type: "category",
          boundaryGap: false,
          data: item.data.c_when,
          axisLabel: {
            formatter: function (params) {
              return params.split(" ")[0];
            },
          },
        });
        multiYAxis.push({
          gridIndex: i,

          type: item.name == "COD（化学需氧量）(mg/L)" ? "value" : "value",
          minInterval: 1,
          name: item.name,
          //   nameRotate: 90,
          //   nameGap: 50,
          //   offset:100,
          nameLocation: "end",
          nameTextStyle: {
            color: '#fff'
          }
        });
        multiSeriesData.push({
          xAxisIndex: i,
          yAxisIndex: i,
          name: item.name,
          smooth: true,
          showSymbol: false,
          type: "line",
          data: item.data.c_value,
          sampling: "lttb",
        });
      });

      // for (let i = 0; i < this.chartdata.length; i++) {
      //   console.log("element",this.chartData[i])
      //   const element = this.chartData[i]
      //   const datalist = element.data
      //
      //
      //   datalist.forEach(item => {
      //     dataseries.push([item.c_time, item.c_value])
      //   })
      //   dataseries = dataseries.reverse()
      //
      //       multiSeriesData.push({
      //         xAxisIndex: i,
      //         yAxisIndex: i,
      //         name: element.c_name,
      //         smooth: true,
      //         showSymbol: false,
      //         type: 'line',
      //         data: datalist.c_value,
      //         sampling: 'lttb'
      //
      //       })
      //     }

      this.chart.setOption({
        // backgroundColor: '#394056',
        // title: {
        //   top: 20,
        //   text: this.chartName,
        //   textStyle: {
        //     fontWeight: 'normal',
        //     fontFamily: "siyuan",
        //     fontSize: 16,
        //     color: '#333'
        //   },
        //   left: '1%'
        // },
        // 竖线颜色
        // tooltip: {
        //     trigger: 'axis',
        // },
        tooltip: {
          trigger: "axis",
          formatter: function (params) {
            //console.log("params",params)
            var res = "<div><p>时间：" + params[0].axisValue + "</p></div>";
            for (var i = 0; i < params.length; i++) {
              res +=
                "<p>" +
                params[i].marker +
                params[i].seriesName +
                ":" +
                params[i].data +
                "</p>";
            }
            return res;
          },
        },
        axisPointer: {
          link: {
            // 表示所有 xAxisIndex 为 0、3、4 和 yAxisName 为 'someName' 的坐标轴联动。
            xAxisIndex: multixAxisIndex,
          },
        },
        // dataZoom:[
        //     {
        //         type:"slider",//slider表示有滑动块的，
        //         show:true,
        //         xAxisIndex:[0],//表示x轴折叠
        //         start:30,//数据窗口范围的起始百分比,表示1%
        //         end:60//数据窗口范围的结束百分比,表示35%坐标
        //     }
        // ],
        // 检测项
        // legend: {
        //   top: 20,
        //   icon: 'rect',
        //   itemWidth: 14,
        //   itemHeight: 5,
        //   itemGap: 13,
        //   data: this.legends,
        //   right: '4%',
        //   textStyle: {
        //     fontSize: 12,
        //     fontFamily: "siyuan",
        //     color: '#333'
        //   }
        // },
        title: multiTile,
        // 表格大小
        grid: multiGrid,
        // x轴颜色
        xAxis: multiXAxis,
        // y轴颜色
        yAxis: multiYAxis,
        series: multiSeriesData,
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/charts/echatline.vue